import React, { Component } from 'react';
import { connect } from 'react-redux';
import institutionLogo from '../../../assets/img/logo-binus-white.png';
import beelajarLogo from '../../../assets/img/beelajar.png';
import Image from '../../image';
import Skeleton from 'react-loading-skeleton';

type MyProps = {
  config: any;
};

type MyState = { value: string };

class LayoutLogo extends Component<MyProps, MyState> {
  render() {
    return (
      <div className="logo-wrapper d-flex flex-row">
        {this.props.config == null ? (
          <Skeleton height={100} />
        ) : (
          <>
            <div className="institution-logo pr-3">
              <Image
                src={this.props.config.logo[0].imageFilePath}
                alt="Binus University"
              />
            </div>
            <div className="beelajar-logo pl-2">
              <Image
                src={this.props.config.logo[1].imageFilePath}
                className="img-fluid"
                alt="Beelajar"
              />
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    config: state.config.data
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutLogo);
